import { PathWithId } from "@constellation-academy/epic-ui";
import { InstructorEditPath } from "../instructor-edit/instructor-edit.paths";

export class InstructorsPath extends PathWithId<typeof InstructorsPath> {
	static readonly pathKey = "instructors";
	static readonly idKey = "instructorId";
	static readonly childPaths = [InstructorEditPath];
}
